import { Component } from '@angular/core';

@Component({
  selector: 'app-tile-demo-api-spec',
  imports: [],
  templateUrl: './tile-demo-api-spec.component.html',
  styleUrl: './tile-demo-api-spec.component.scss',
})
export class TileDemoApiSpecComponent {}
